"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useWindowResize;

var _react = require("react");

var _throttle = _interopRequireDefault(require("lodash/fp/throttle"));

function useWindowResize(onResizeCallback) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  (0, _react.useEffect)(function () {
    var throttledCallback = (0, _throttle.default)(timeout, onResizeCallback);
    window.addEventListener('resize', throttledCallback, false);
    return function () {
      return window.removeEventListener('resize', throttledCallback, true);
    };
  }, [onResizeCallback, timeout]);
}